/* eslint-disable import/no-cycle */
import React from "react";
import { useHistory } from "react-router-dom";

import moment from "moment";

import { Dialog } from "primereact";
import ReactPaginate from "react-paginate";
import { Spinner } from "react-bootstrap";
import toastUtils from "../../../../../utils/ToastUtils";

import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import ChooseModal from "../../../../components/modals/choose-modal";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";
import { DocumentCard } from "../../../../components/cards";

import { FilterModel } from "../../../../../domain/models/enum";
import {
  DocumentsModel,
  DocumentsResponseModel,
} from "../../../../../domain/models/documents";

import { Cards, CardWrapper, Wrapper, ContainerButtonActions, IframeStyled } from "./styles";
import { theme } from "../../../../styles/theme";
import { PaginateStyled } from "../../../../components/datagrid/styled";

import { documentType } from "../../../../../utils";
import {
  cancelFiscalNote,
  displayCancelMessage,
} from "./utils";
import {
  showErrorMessage,
  handleClickInfo,
  readDocumentAsBase64,
  adjustMimeTypeToPdf,
} from "../../../../helpers";
import { settings } from "../../../../../main/configs/settings";
import { Filters } from "./filters";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";
import TemplateInvoice from "../../../../components/template-invoice";
import ButtonComponent from "../../../../components/button";
import fetchInvoicePDF from "./utils/fetch-invoice-pdf";
import { makeRemoteInvoice } from "../../../../../main/factories/usecases/invoice/remote-invoice-factory";
import { makeRemoteFiscalNote } from "../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";
import { makeRemoteAdminFiscalNote } from "../../../../../main/factories/usecases/fiscal-note/remote-admin-fiscal-note-factory";
import { HistoricFiscalNoteModel } from "../../../../../domain/models/fiscal-note";
import { StatusEnum, statusEnumList } from "../../../../../utils/status-enum";

type PageProps = {
  list: DocumentsResponseModel | undefined;
  setParams: any;
  loading?: boolean;
  handleReload: () => void;
  isSuperAdmin?: boolean;
};

export const formCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

export const formCurrencyByCountry = (
  localeCountry: string,
  currencyCountry: string,
): Intl.NumberFormat => {
  const formatedNumber = new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: currencyCountry,
    minimumFractionDigits: 2,
  });
  return formatedNumber;
};

const InvoiceListPage: React.FC<PageProps> = ({
  list,
  setParams,
  loading,
  handleReload,
  isSuperAdmin,
}) => {
  const [selected, setSelected] = React.useState<
    DocumentsModel | undefined
  >();
  const [remove, setRemove] = React.useState<DocumentsModel | undefined>();
  const [copy, setCopy] = React.useState<DocumentsModel | undefined>();
  const [view, setView] = React.useState<any | undefined>();
  const [historicModal, setHistoricModal] = React.useState<{ items: HistoricFiscalNoteModel[]; fiscalNoteId: number } | undefined>();
  const [jsonPreview, setJsonPreview] = React.useState<object | null>(null);
  const [jsonLoading, setJsonLoading] = React.useState(false);

  const history = useHistory();

  const [shouldForcePage, setShouldForcePage] = React.useState<boolean>(false);

  const preview = async (data: DocumentsModel): Promise<void> => {
    try {
      if (data?.fiscalNote?.id) {
        const doc = await makeRemoteFiscalNote().preview({ id: data.fiscalNote.id, type: "pdf" });
        const base64String = await readDocumentAsBase64(doc);
        const pdf = adjustMimeTypeToPdf(base64String);
        setView({ doc: data.fiscalNote, pdf, isFiscalNote: true });
      } else if (data?.invoice?.id) {
        const doc = await fetchInvoicePDF(data.invoice.id);
        const base64String = await readDocumentAsBase64(doc);
        setView({ doc: data.invoice, pdf: base64String, isFiscalNote: false });
      }
    } catch (error) {
      console.error("Erro ao pré-visualizar:", error);
    }
  };

  const setDocumentView = (data: DocumentsModel): void => {
    if (data?.fiscalNote?.id) {
      setView({ doc: data.fiscalNote, isFiscalNote: true });
    } else {
      setView({ doc: data.invoice, isFiscalNote: false });
    }
  };

  const exportDocument = async (data: DocumentsModel): Promise<void> => {
    try {
      if (data?.fiscalNote?.id) {
        await makeRemoteFiscalNote().exportNote({ id: data.fiscalNote.id, type: "pdf" });
      } else if (data?.invoice?.id) {
        await makeRemoteInvoice().export(data.invoice.id);
      }
    } catch (error: any) {
      const msg = error?.response?.data?.detail || error?.response?.data?.messageClient || error?.message || "Erro ao exportar nota.";
      toastUtils.showMessage({ type: "error", message: msg });
    }
  };

  const exportNote = async (type: "xml" | "pdf"): Promise<void> => {
    try {
      if (view?.isFiscalNote) {
        await makeRemoteFiscalNote().exportNote({ id: view?.doc.id, type });
      } else {
        await makeRemoteInvoice().export(view?.doc?.id as number);
      }
    } catch (error: any) {
      const msg = error?.response?.data?.detail || error?.response?.data?.messageClient || error?.message || "Erro ao exportar nota.";
      toastUtils.showMessage({ type: "error", message: msg });
    }
  };

  const fields: ItemField[] = [
    {
      title: "Número",
      key: "id",
      size: 80,
      renderItem: (data: DocumentsModel) =>
        data?.fiscalNote?.nfseNumber || data?.fiscalNote?.id || data?.invoice?.id || "-",
    },
    {
      title: "Data",
      key: "issuedOn",
      size: 110,
      renderItem: (data: DocumentsModel) =>
        moment(data?.issuedOn).format("DD/MM/YYYY"),
    },
    ...(isSuperAdmin
      ? [
        {
          title: "Prestador",
          key: "prestador",
          renderItem: (data: DocumentsModel) => {
            const name = data?.fiscalNote?.developerCompany?.company?.socialReason || "-";
            return <span title={name} style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 180 }}>{name}</span>;
          },
        },
      ]
      : []),
    {
      title: "Tomador",
      key: "companyName",
      renderItem: (data: DocumentsModel) => {
        const name = data?.fiscalNote?.taker?.socialReason || data?.invoice?.companyName || "-";
        return <span title={name} style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 180 }}>{name}</span>;
      },
    },
    {
      title: "Status",
      key: "status",
      renderItem: (data: DocumentsModel) => {
        if (data?.fiscalNote) {
          const historic = data.fiscalNote.historicFiscalNoteList;
          const lastStatus = historic && historic.length > 0
            ? [...historic].sort((a, b) => b.id - a.id)[0]
            : undefined;
          const fullLabel = lastStatus
            ? statusEnumList.find((el) => el.ENUM === lastStatus.status)?.label || lastStatus.status
            : "-";
          const statusLabel = fullLabel.replace(/^Integração - /i, "");
          const isSuccess = lastStatus?.status === "INTEGRATION_SUCCESS";
          const isPending = lastStatus?.status === "PENDING_CONFIRMATION";
          const isExpired = lastStatus?.status === "EXPIRED";
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {isSuccess && <span style={{ color: "#4caf50", fontSize: 16 }}>●</span>}
              {isPending && <span style={{ color: "#FFA726", fontSize: 16 }}>●</span>}
              {isExpired && <span style={{ color: "#9E9E9E", fontSize: 16 }}>●</span>}
              <span>{statusLabel}</span>
              {historic && historic.length > 0 && (
                <ButtonRound
                  title="Ver histórico"
                  backgroundColor={theme.colors.darkBlue}
                  onClick={() => setHistoricModal({ items: historic, fiscalNoteId: data.fiscalNote?.id as number })}
                  color={theme.colors.blue100}
                >
                  <Icons height={16} width={16} name="information" color={theme.colors.blue100} />
                </ButtonRound>
              )}
            </div>
          );
        }
        return statusEnumList.find((el) => el.ENUM === data?.status)?.label;
      },
    },
    {
      title: "Valor",
      key: "name",
      renderItem: (data: DocumentsModel) =>
        formCurrency.format(Number(data?.fiscalNote?.noteValue || data?.invoice?.total || 0)),
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data: DocumentsModel) => (
        <ContainerButtonActions>
          {(data?.fiscalNote?.historicFiscalNoteList?.slice().sort((a, b) => b.id - a.id)[0]?.status === StatusEnum.INTEGRATION_SUCCESS || data?.fiscalNote?.historicFiscalNoteList?.slice().sort((a, b) => b.id - a.id)[0]?.status === StatusEnum.INTEGRATION_CANCELED) && (
            <>
              <ButtonRound
                backgroundColor={theme.colors.darkBlue}
                title="Visualizar"
                onClick={() => preview(data)}
                color={theme.colors.green}
              >
                <Icons
                  height={25}
                  width={25}
                  name="eye"
                  color={theme.colors.green}
                />
              </ButtonRound>
              <ButtonRound
                title="Download"
                backgroundColor={theme.colors.darkBlue}
                onClick={() => exportDocument(data)}
                color={theme.colors.lightBlue}
              >
                <Icons
                  height={20}
                  width={20}
                  name="download"
                  color={theme.colors.primary}
                />
              </ButtonRound>
            </>
          )}

          <ButtonRound
            title="Copiar"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => setCopy(data)}
            color={theme.colors.blue100}
          >
            <Icons
              height={20}
              width={20}
              name="copy"
              color={theme.colors.blue400}
            />
          </ButtonRound>

          <ButtonRound
            hasRecurrence="true"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              if (data?.fiscalNote?.historicFiscalNoteList?.slice().sort((a, b) => b.id - a.id)[0]?.status !== StatusEnum.INTEGRATION_SUCCESS) {
                showErrorMessage("Não é possível cancelar uma nota que já foi enviada para integração.");
                return;
              }
              setRemove(data);
            }}
            title="Cancelar"
            color={theme.colors.red}
            minWidth="200px"
          >
            <Icons
              height={15}
              width={15}
              name="close"
              color={theme.colors.red}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));

    setShouldForcePage(false);
  };

  const handleError = (error: any): any => {
    showErrorMessage(
      error?.userMessage || error?.detail || "Erro desconhecido",
    );
  };

  const fetchJson = async (fiscalNoteId: number): Promise<void> => {
    setJsonLoading(true);
    try {
      const json = await makeRemoteAdminFiscalNote().getPlugNotasJson(fiscalNoteId);
      setJsonPreview(json);
    } catch (error: any) {
      showErrorMessage(error?.message || "Erro ao buscar JSON");
    } finally {
      setJsonLoading(false);
    }
  };

  const handleCancelNote = async (noteId: number): Promise<void> => {
    try {
      const response = await cancelFiscalNote(noteId);
      handleReload();
      const lastStatus = response.historicFiscalNoteList?.slice().sort((a, b) => b.id - a.id)[0]?.status;
      displayCancelMessage(lastStatus ?? "");
    } catch (error) {
      handleError(error);
    } finally {
      setRemove(undefined);
    }
  };

  return (
    <Wrapper>
      <BackButtom text="NFS-e para o Exterior" />
      <CardWrapper>
        <Filters onSubmit={e => setParams(e)} />
        <Link to="/exterior/create" invertColor={false} style={{ maxWidth: 240 }}>
          Nova NFS-e Exterior <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <Cards>
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}

        {!loading &&
          list?.content.map((item: any) => (
            <DocumentCard
              key={item.id}
              actions={{
                detail: () => handleClickInfo(item),
                view: () => preview(item),
                download: () => setDocumentView(item),
                cancel: () => console.log("cancel"),
              }}
              docType={documentType.find((el) => el.ENUM === item.type)?.label}
              number={item?.fiscalNote?.nfseNumber || item?.invoice?.id}
              date={moment(item?.issuedOn).format("DD/MM/YYYY")}
              taker={
                item?.fiscalNote?.taker?.socialReason ||
                item?.invoice?.companyName
              }
              status={statusEnumList.find((el) => el.ENUM === item?.status)?.label}
              value={
                formCurrency.format(
                  Number(item?.fiscalNote?.noteValue || item?.invoice?.total),
                ) as any
              }
            />
          ))}

        <PaginateStyled>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            pageRangeDisplayed={settings.perPage}
            previousLabel="<"
            nextClassName="next-button"
            prevClassName="prev-button"
            pageCount={list?.totalPages || 0}
            forcePage={shouldForcePage ? 0 : undefined}
            onPageChange={(e: any) => handlePage(e.selected)}
          />
        </PaginateStyled>
      </Cards>

      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
        shouldForcePage={shouldForcePage}
      />
      <ChooseModal
        text="Você deseja realmente cancelar a nota fiscal?"
        onConfirm={() => remove?.id && handleCancelNote(remove?.id)}
        onCancel={() => setRemove(undefined)}
        isVisible={!!remove}
        toggleVisibility={() => setRemove(undefined)}
      />
      <ChooseModal
        text="Você deseja copiar os dados desta nota fiscal para uma nova?"
        onConfirm={() => {
          history.push("/exterior/create", { copyNote: copy });
          setCopy(undefined);
        }}
        onCancel={() => setCopy(undefined)}
        isVisible={!!copy}
        toggleVisibility={() => setCopy(undefined)}
      />
      <Dialog
        header="Histórico de Status"
        visible={!!historicModal}
        style={{ width: window.innerWidth < 768 ? "90vw" : "40vw", background: theme.colors.darkBlue }}
        headerStyle={{ background: theme.colors.darkBlue, color: theme.colors.white }}
        contentStyle={{ background: theme.colors.darkBlue }}
        footer={null}
        onHide={() => setHistoricModal(undefined)}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {historicModal && [...historicModal.items].sort((a, b) => a.id - b.id).map((item) => (
            <div
              key={item.id}
              style={{
                padding: "12px 16px",
                borderRadius: 8,
                background: theme.colors.blue900,
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              <span style={{ color: theme.colors.blue100, fontWeight: 600 }}>
                {statusEnumList.find((el) => el.ENUM === item.status)?.label || item.status}
              </span>
              <span style={{ color: theme.colors.gray500, fontSize: 13 }}>
                {moment.utc(item.createdAt).utcOffset(-180).format("DD/MM/YYYY HH:mm:ss")}
              </span>
              {item.message && (
                <span style={{ color: theme.colors.lightGray, fontSize: 13 }}>
                  {item.message}
                </span>
              )}
            </div>
          ))}
          {isSuperAdmin && historicModal && (
            <button
              type="button"
              onClick={() => fetchJson(historicModal.fiscalNoteId)}
              disabled={jsonLoading}
              style={{
                marginTop: 12,
                padding: "6px 12px",
                background: "transparent",
                border: `1px solid ${theme.colors.gray800}`,
                borderRadius: 100,
                color: theme.colors.lightBlue,
                fontSize: 12,
                fontFamily: "Poppins, sans-serif",
                cursor: "pointer",
              }}
            >
              {jsonLoading ? "Carregando..." : "{ } Ver JSON"}
            </button>
          )}
        </div>
      </Dialog>

      <Dialog
        header="JSON PlugNotas"
        visible={!!jsonPreview}
        style={{ width: window.innerWidth < 768 ? "95vw" : "60vw", background: theme.colors.darkBlue }}
        headerStyle={{ background: theme.colors.darkBlue, color: theme.colors.white }}
        contentStyle={{ background: theme.colors.darkBlue, padding: 0 }}
        footer={null}
        onHide={() => setJsonPreview(null)}
      >
        {jsonPreview && (
          <div style={{ padding: 16, maxHeight: "70vh", overflow: "auto" }}>
            <pre style={{
              background: "#0E1428",
              color: "#91DBE4",
              borderRadius: 12,
              padding: 16,
              fontSize: 12,
              lineHeight: 1.5,
              overflow: "auto",
              maxHeight: "65vh",
              margin: 0,
              border: "1px solid rgba(255, 255, 255, 0.05)",
            }}>
              {JSON.stringify(jsonPreview, null, 2)}
            </pre>
          </div>
        )}
      </Dialog>
      <Dialog
        header="Nota Fiscal:"
        visible={!!selected}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        headerStyle={{
          background: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          background: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        footer={null}
        onHide={() => setSelected(undefined)}
      >
        <TemplateInvoice
          invoice={selected}
          onCancelCallback={() => setSelected(undefined)}
        />
      </Dialog>
      <Dialog
        visible={!!view}
        style={{
          width: window.innerWidth < 768 ? "90vw" : "50vw",
          background: theme.colors.darkBlue,
        }}
        headerStyle={{ background: theme.colors.darkBlue }}
        contentStyle={{ background: theme.colors.darkBlue }}
        footer={null}
        onHide={() => setView(undefined)}
      >
        <div>
          {view?.pdf && (
            <IframeStyled title="pdf" src={`${view?.pdf}#toolbar=0`} />
          )}
        </div>
        <div
          className="mt-4 d-flex"
          style={{
            background: theme.colors.darkBlue,
          }}
        >
          {view?.isFiscalNote && (
            <div className="w-50">
              <ButtonComponent
                type="button"
                title="Download XML"
                icon="download"
                color={theme.colors.white}
                backgroundColor={theme.colors.blue400}
                onClick={() => exportNote("xml")}
              />
            </div>
          )}
          <div className={view?.isFiscalNote ? "ms-2 w-50" : "ms-2 w-full"}>
            <ButtonComponent
              type="button"
              title="Download PDF"
              icon="download"
              color={theme.colors.white}
              backgroundColor={theme.colors.blue400}
              onClick={() => exportNote("pdf")}
            />
          </div>
        </div>
      </Dialog>
    </Wrapper>
  );
};
export default InvoiceListPage;
